import { channelConstants } from './constants/channelConstants';

const channelSave = (channelsInput: any) => {
	return {
		type: channelConstants.ChannelSaveRequest,
		input: channelsInput
	};
};

const channelGetDetail = (id: any, code: any) => {
	return {
		type: channelConstants.ChannelDetailRequest,
		input: { id: id, code: code }
	};
};

const channelGetByfilter = (channelInput: any=null) => {
	return {
		type: channelConstants.ChannelGetByfilterRequest,
		input: channelInput
	};
};

const channelGetAll = (channelInput: any = null) => {
	return {
		type: channelConstants.ChannelGetAllRequest,
		input: channelInput
	}
}

const channelDelete = (id: any) => {
	return {
		type: channelConstants.ChannelDeleteRequest,
		input: id
	};
};

const channelGetFavourite = (channelsInput: any) => {
	return {
		type: channelConstants.ChannelFaviruteRequest,
		input: channelsInput
	};
};

const channelGetNonFavourite = (channelsInput: any) => {
	return {
		type: channelConstants.ChannelnonFaviruteRequest,
		input: channelsInput
	};
};

export const channelAction = {
	channelSave,
	channelGetDetail,
	channelGetByfilter,
	channelGetAll,
	channelDelete,
	channelGetFavourite,
	channelGetNonFavourite
}